import IsEnable from './IsEnable';
import DictType from './DictType';
import DictFrom from './DictFrom';
import InputNumber from './InputNumber';
import EmployeeModal from './EmployeeModal';
import EmployeeModalByOrgAuth from './EmployeeModalByOrgAuth';
import TermYearStyle from './TermYearStyle';
import Tree from './Tree';
import Term from './Term';
import Year from './Year';
import Org from './Org';
import FileGrid from './FileGrid';
import DossierImportTree from './DossierImportTree';
import DossierTemplateTree from './DossierTemplateTree';
import TermRange from './TermRange';
import YearRange from './YearsRange';
import DataGridMul from './DataGridMul';
import DossierUploadTree from './DossierUploadTree';
import FolderMul from './FolderMul';

export default {
    IsEnable,
    DictType,
    DictFrom,
    InputNumber,
    EmployeeModal,
    EmployeeModalByOrgAuth,
    TermYearStyle,
    Tree,
    Term,
    Year,
    Org,
    FileGrid,
    DossierImportTree,
    DossierTemplateTree,
    TermRange,
    YearRange,
    DataGridMul,
    DossierUploadTree,
    FolderMul
}